/**
 * Global config สำหรับ Joyride tour
 * สีและสไตล์ตาม PARTZYNC Design System (partzync-ui-system.mdc)
 *
 * Midnight Navy #001C3D | Action Orange #F26522 | Tech Blue #004799 | Pure White #FFFFFF
 */

/** สีหลัก PARTZYNC */
export const TOUR_COLORS = {
  /** พื้นหลัง Dark, ตัวอักษรบนพื้นขาว */
  midnightNavy: "#001c3d",
  /** ปุ่ม CTA, สถานะสำคัญ, Active */
  actionOrange: "#f26522",
  /** ไอคอน, ลิงก์, Progress */
  techBlue: "#004799",
  /** พื้นหลัง Light, ตัวอักษรบนพื้นเข้ม */
  pureWhite: "#ffffff",
  /** Inactive / Disabled */
  lightGrey: "#94a3b8",
} as const;

/** ข้อความปุ่ม tour (ພາສາລາວ) */
export const TOUR_LOCALE = {
  back: "ກັບ",
  close: "ປິດ",
  last: "ສິ້ນສຸດ",
  next: "ຕໍ່",
  open: "ເປີດ",
  skip: "ຂ້າມ",
} as const;

/** ค่า default ของ Joyride (continuous, showProgress, showSkipButton) */
export const TOUR_DEFAULT_PROPS = {
  continuous: true,
  showProgress: true,
  showSkipButton: true,
} as const;

/** สไตล์ tooltip และปุ่มตาม PARTZYNC Design System */
export const TOUR_STYLES = {
  options: {
    primaryColor: TOUR_COLORS.actionOrange,
    zIndex: 10000,
  },
  tooltip: {
    borderRadius: "0.625rem",
    border: `1px solid ${TOUR_COLORS.techBlue}`,
    padding: "1.25rem 1.5rem",
    backgroundColor: TOUR_COLORS.pureWhite,
    fontFamily: '"Noto Sans Lao", ui-sans-serif, system-ui, sans-serif',
  },
  tooltipContainer: {
    textAlign: "left" as const,
  },
  tooltipTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: TOUR_COLORS.midnightNavy,
    marginBottom: "0.5rem",
  },
  tooltipContent: {
    fontSize: "0.875rem",
    color: TOUR_COLORS.midnightNavy,
    lineHeight: 1.5,
    padding: 0,
  },
  buttonNext: {
    borderRadius: "0.375rem",
    backgroundColor: TOUR_COLORS.actionOrange,
    color: TOUR_COLORS.pureWhite,
    fontSize: "0.875rem",
    fontWeight: 500,
    padding: "0.5rem 1rem",
    border: "none",
  },
  buttonBack: {
    borderRadius: "0.375rem",
    color: TOUR_COLORS.midnightNavy,
    fontSize: "0.875rem",
    fontWeight: 500,
    padding: "0.5rem 1rem",
    border: `1px solid ${TOUR_COLORS.midnightNavy}`,
    backgroundColor: "transparent",
  },
  buttonSkip: {
    borderRadius: "0.375rem",
    color: TOUR_COLORS.lightGrey,
    fontSize: "0.875rem",
    fontWeight: 400,
    padding: "0.5rem 1rem",
  },
  overlay: {
    backgroundColor: "rgba(0, 28, 61, 0.5)",
  },
  spotlight: {
    borderRadius: "0.5rem",
  },
} as const;
